
export default function Error( props) {
  return props.message || 'Error';
}
